module.exports = __webpack_public_path__ + "img/logo-rebeca-lan.0dd01ed7.svg";